import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { persistStore, persistReducer } from 'redux-persist'

import storage from 'redux-persist/lib/storage'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

import rootReducer from './root.reducer'

const history = createBrowserHistory()

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loggedInUser'],
}

const pReducer = persistReducer(persistConfig, rootReducer(history))

const store = configureStore({
  reducer: pReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
    }).concat(routerMiddleware(history)),
  preloadedState: {},
  devTools: process.env.REACT_APP_STAGE !== 'prod',
})

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch

export const persistor = persistStore(store)

export default store

export * from './common'
export * from './root.models'
